var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "saveAndContinueModal",
      "centered": "",
      "size": "md",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "save-and-continue-header"
        }, [_c('h4', [_vm._v("Save And Continue Later")]), _c('b-button', {
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    ref: "saveAndContinueContainer",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "save-and-continue-modal-content"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          ref: "saveAndContinueModalContainer",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.submit);
            }
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true,
              email: true
            },
            "labelFor": "savecont_email",
            "labelName": "Email",
            "vmodel": _vm.email,
            "formGroupClass": "col-xxl-12 col-xl-12 col-lg-12 mb-6",
            "api-errors": _vm.apiErrors
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.email = $event;
            }
          }
        })], 1), _c('div', {
          staticClass: "form-group text-center mb-3 mt-3"
        }, [_c('button', {
          staticClass: "btn univ-btn btn-secondary",
          attrs: {
            "type": "submit",
            "disabled": _vm.isSubmit
          }
        }, [_vm._v(" " + _vm._s(_vm.isSubmit ? "Saving..." : "Save") + " ")])])])];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }